/* eslint-disable @next/next/no-sync-scripts */
/* eslint-disable react/no-danger */
/* eslint-disable react-hooks/exhaustive-deps */
import { transformToHtml } from "../../utils/CommonUtils";
import ErrorFlightDistanceDT from "./Error";
import Token from "./Token";

export default function FlightDistanceDT(props) {
  const {
    appConfig,
    main_div: mainDiv,
    seo_content_desc: seoContentDesc,
    activeDate,
    srcCoordinates,
    destCoordinates,
    blocksData,
    lang,
    ccde,
    isGoibibo = false,
  } = props?.data || {};

  let cssPath;
  let jsPath;
  // let imagePath;
  // let minExt;
  let lazyLoadingPath;
  let topOverlayPath;
  let seoWidgetPath;
  if (appConfig && appConfig.liveMode) {
    cssPath = `https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/css`;
    jsPath = `https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js`;
    // imagePath = `${appConfig.imagePath}/images`;
    // minExt = '.min';
  } else {
    cssPath = "http://localhost:3000/_next/static/css";
    jsPath = "http://localhost:3000/_next/static/js";
    // imagePath = '/images';
    // minExt = '';
  }
  lazyLoadingPath = `${jsPath}/lazyLoading.min.js`;
  topOverlayPath = isGoibibo ? `${jsPath}/topOverlayGI.min.js` : `${jsPath}/top_overlay.min.js`;
  seoWidgetPath = lang === "hin" ? `${jsPath}/hiSeoWidget2.min.js` : `${jsPath}/seoWidget2.min.js`;
  const intentOfferOverlayCSSPath = `${cssPath}/intentOfferOverlay.min.css`;
  const intentOfferOverlayJSPath = `${jsPath}/intentOffer.min.js`;
  const googleTagId = isGoibibo ? "GTM-5VDCXLQ" : "GTM-NWV3K7C";
  const googleTagSrc = `https://www.googletagmanager.com/ns.html?id=${googleTagId}`;
  const googletTagString = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${googleTagId}');
  `;

  return (
    <>
      {ccde || ccde === "in" || ccde === "IN" ? (
        <noscript>
          <iframe
            title="distance"
            src={googleTagSrc}
            height="0"
            width="0"
            style={{ display: "none", visibility: "hidden" }}
          />
        </noscript>
      ) : (
        <></>
      )}
      <script
        dangerouslySetInnerHTML={{
          __html: `
      var srcCoordinates = ${JSON.stringify(srcCoordinates)};
      var destCoordinates = ${JSON.stringify(destCoordinates)};
      `,
        }}
      />
      <div className="newSection">
        <div className="fare-section marginTop126 hidden-xs" id="seoContentDesc">
          {transformToHtml(seoContentDesc)}
        </div>
        <div id="fare-header" class="weekly-fare-section container">
          <div class="mobile-header">
            <div class="makeFlex hrtlCenter">
              <a href="https://www.makemytrip.com/flights/">
                <span class="back-button header-back-icon" />
              </a>
              <div class="trip-details">
                <p class="trip-summary font12">
                  {lang === "hin"
                    ? `${activeDate && activeDate !== "" ? "|" : ""} 1 वयस्क | इकोनॉमी`
                    : `${activeDate && activeDate !== "" ? "|" : ""} 1 Adult | Economy`}
                </p>
              </div>
            </div>
          </div>
          <div class="makeFlex FareStrip">
            <div class="weekly-fare-carousel">
              <div class="weekly-fare-carousel-container weekly-scroll" id="fareStripLoader">
                <div class="placeholder-content" id="placeholder" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="fli-intl-container clearfix">
        <div className="fli-intl-lhs">
          <div class="seoOnlyBlock airline-left-container nopadding-mob paddR0 ">
            {mainDiv && mainDiv !== "" ? (
              <div dangerouslySetInnerHTML={{ __html: mainDiv }} />
            ) : (
              <ErrorFlightDistanceDT />
            )}
            <div dangerouslySetInnerHTML={{ __html: blocksData.contentTop }} />
            {mainDiv && mainDiv !== "" ? (
              <div dangerouslySetInnerHTML={{ __html: blocksData.contentMiddle }} />
            ) : (
              ""
            )}
            <div dangerouslySetInnerHTML={{ __html: blocksData.contentBottom }} />
            <div dangerouslySetInnerHTML={{ __html: blocksData.bottomBlock }} />
          </div>
          <div class="seoOnlyBlock col-lg-3 col-md-12 col-sm-12 col-xs-12 airline-right-container nopadding-mob paddR0 ">
            {transformToHtml(blocksData.rightBlock)}
            {transformToHtml(blocksData.leftBlock)}
          </div>
        </div>
      </div>
      <Token data={props} />
      <script defer type="text/javascript" src={`${lazyLoadingPath}`} />
      {lang === "hin" ? (
        <>
          <style>
            {`
            .filter-options .ui-datepicker {
                width: 675px!important;
            }
            .ui-datepicker-multi-2 .ui-datepicker-group {
                margin: 14px 22px 0;
            }
            .filter-options .ui-datepicker .ui-datepicker-header .ui-datepicker-title {
                font-size: 18px !important;
                font-weight: bolder !important;
                color: #000 !important;
                text-align: center !important;
            }
            .filter-options .ui-datepicker .ui-datepicker-header .ui-datepicker-title .ui-datepicker-year {
                font-size: 18px !important;
                font-weight: bolder !important;
                color: #000 !important;
                text-align: center !important;
            }
            .modify-search-label {
                line-height: 18px !important;
            }
            .filter-options .ui-datepicker-calendar thead th {
                font-size: 1em;
            }

            .modify-search-input-field {
                line-height: 21px !important;
            }`}
          </style>
        </>
      ) : (
        <></>
      )}
      <script type="text/javascript" src={`${seoWidgetPath}`} />
      <script defer type="text/javascript" src={`${topOverlayPath}`} />
      <div id="seo-bottom" class="seo">
        <input
          name="domain_id"
          id="domain_id"
          type="hidden"
          value="www_intl_flight_makemytrip_com"
        />
      </div>
      <link href={`${intentOfferOverlayCSSPath}`} rel="stylesheet" />
      <script defer type="text/javascript" src={`${intentOfferOverlayJSPath}`} />
      <div dangerouslySetInnerHTML={{ __html: blocksData.top_overlay }} />
      {ccde && (ccde === "" || ccde === "in" || ccde === "IN") ? (
        <script dangerouslySetInnerHTML={{ __html: googletTagString }} />
      ) : null}
    </>
  );
}
